var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_714cd67f"]},_vm.$listeners),[_c('div',{class:[("theme-"+(_vm.themeType)+" them-container")]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }